import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

/**
 * Tag input bound to an array of strings. Used for video-pointer example links.
 * Parent owns the array via [tags]/(tagsChange).
 */
@Component({
  selector: 'bb-tag-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="flex flex-wrap items-center gap-2 rounded-md border border-border bg-card p-2 focus-within:border-brand-studio focus-within:ring-2 focus-within:ring-brand-studio/25">
      @for (tag of tags(); track $index) {
        <span
          class="inline-flex items-center gap-1.5 rounded-sm bg-brand-studio/10 py-1 pl-3 pr-2 text-sm font-medium text-brand-studio-dark dark:text-brand-studio">
          {{ tag }}
          <button
            type="button"
            [attr.aria-label]="'Remove ' + tag"
            class="text-base leading-none opacity-60 hover:opacity-100"
            (click)="removeAt($index)">×</button>
        </span>
      }
      <input
        [value]="draft()"
        (input)="draft.set($any($event.target).value)"
        (keydown)="onKeydown($event)"
        [placeholder]="placeholder()"
        class="min-w-[140px] flex-1 border-none bg-transparent p-1 text-sm outline-none placeholder:text-muted-foreground" />
    </div>
  `,
})
export class BbTagInput {
  readonly tags = input<string[]>([]);
  readonly placeholder = input<string>('Type and press Enter');
  readonly tagsChange = output<string[]>();

  readonly draft = signal('');

  onKeydown(event: KeyboardEvent): void {
    const value = this.draft().trim();
    if (event.key === 'Enter' && value) {
      event.preventDefault();
      this.tagsChange.emit([...this.tags(), value]);
      this.draft.set('');
    } else if (event.key === 'Backspace' && !this.draft() && this.tags().length) {
      this.tagsChange.emit(this.tags().slice(0, -1));
    }
  }

  removeAt(index: number): void {
    this.tagsChange.emit(this.tags().filter((_, i) => i !== index));
  }
}
